import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AclService, SessionService } from '@app/core';


@Injectable()
export class OrganizationGuard  {
  private _aclQueryService = inject(AclService);
  private _router = inject(Router);
  private _aclService = inject(AclService);
  private _sessionService = inject(SessionService);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

    if (this._aclService.hasAnyOrganizationLevelPermissions()) {
      return true;
    }

    return this._router.createUrlTree(['/parent']);
  }

}
